export const ITEM_NOT_AVAILALBLE_FAULT_TYPE =
    'ProductItemNotAvailableException';
